import React, { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import { TextField, Box, Grid, Typography, Card, Paper, Button, IconButton, Snackbar, CardContent } from '@mui/material';
import axios from 'axios'
import { useLocation, useNavigate } from "react-router-dom";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CloseIcon from '@mui/icons-material/Close';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import DialogContent from '@mui/material/DialogContent';
import { Icon } from '@iconify/react';
import SaveIcon from '@mui/icons-material/Save';
import { addInvoicePrintTitle, editPrintInvoiceTitle, getInvoicePrintTitleList } from '../../../actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { dateConversionOnEntryPageWithTime } from '../../reusableComponent/dateConversionOnEntryPage';
import styles from '.././../../styles.module.css';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import { ERPinput, ERPinputNo } from '../../reusableComponent/ErpTextField';
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';


const InvoicePrintTitleSetting = (props) => {
    const { handleSubmit } = useForm();
    const dispatch = useDispatch();

    let navigate = useNavigate();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const [successMessage, setSuccessMessage] = useState(null);
    const [tableData, setTableData] = React.useState([]);
    const rows = useSelector(state => state.invoicePrintTitle.invoicePrintTitle)

    const [noOfCopies, setNoOfCopies] = useState('');

    const [titles, setTitles] = useState(
        {
            'title1': '',
            'title2': '',
            'title3': '',
            'title4': '',
            'title5': '',
            'title6': '',
        }
    );



    const fetchData = () => {
        dispatch(getInvoicePrintTitleList({ companyId: userInfo.companyId }))
    }
    useEffect(() => {
        fetchData()
    }, []);

    const handleChangeNoofCopies = (event) => {
        setNoOfCopies(event.target.value);
        for (let key in titles) {
            if (key >= `title${event.target.value}`) {
                titles[key] = ''
            }
            else continue;
        }
    };

    const handleChangeTitle1 = (event) => {
        setTitles({ ...titles, 'title1': event.target.value })
    };
    const handleChangeTitle2 = (event) => {
        setTitles({ ...titles, 'title2': event.target.value })
    };
    const handleChangeTitle3 = (event) => {
        setTitles({ ...titles, 'title3': event.target.value })
    };
    const handleChangeTitle4 = (event) => {
        setTitles({ ...titles, 'title4': event.target.value })
    };
    const handleChangeTitle5 = (event) => {
        setTitles({ ...titles, 'title5': event.target.value })
    };
    const handleChangeTitle6 = (event) => {
        setTitles({ ...titles, 'title6': event.target.value })
    };

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.invoicePrintTitle.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
                fetchData();
            }
        }
    }, [shouldShowMsg, responseMessage, fetchData]);

    useEffect(() => {
        console.log(rows)
        if (rows.length > 0) {
            setNoOfCopies(rows[0].noOfCopies)
            setTitles({
                'title1': rows[0].title1,
                'title2': rows[0].title2,
                'title3': rows[0].title3,
                'title4': rows[0].title4,
                'title5': rows[0].title5,
                'title6': rows[0].title6,
            })
        }
    }, [rows]);

    const onSubmit = (event) => {
        const sending_data = {
            companyId: userInfo.companyId,
            id: rows.length > 0 ? rows[0].id : null,
            noOfCopies: noOfCopies,
            title1: titles.title1,
            title2: titles.title2,
            title3: titles.title3,
            title4: titles.title4,
            title5: titles.title5,
            title6: titles.title6,
            createdBy: rows.length > 0 ? rows[0].createdBy : userInfo.userId,
            createdAt: rows.length > 0 ? rows[0].createdAt : dateConversionOnEntryPageWithTime(new Date()),
            modifiedBy: rows.length > 0 ? userInfo.userId : null,
            modifiedAt: rows.length > 0 ? dateConversionOnEntryPageWithTime(new Date()) : '',
        }
        if (rows.length > 0) {
            dispatch(editPrintInvoiceTitle(sending_data));
        } else {
            dispatch(addInvoicePrintTitle(sending_data));
        }
    }

    const handleCloseSuccessMsg = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessMessage(false)
    };

    const actionMsg = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSuccessMsg}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <>   <Breadcrumb
        routeSegments={[
            { name: 'Settings', path: '/settings' },
            { name: 'Create Invoice Print Title' },
        ]}
    />
        <Paper className={`${styles.list_container}`}>
         
            {/* <Box sx={{ display: 'flex',paddingLeft: '50px', }}>
                <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                    <Grid item md={12} xs={12}>
                        <Typography className={`${styles.page_title}`}>Invoice Print Title</Typography>
                    </Grid>
                </Grid>
            </Box> */}
             <Box sx={{ m: 4}} > </Box>
            <form onSubmit={handleSubmit(onSubmit)}>

                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={2} style={{ minHeight: '350px', paddingLeft: '50px' }}>
                        <Grid item xs={4} >
                            <Typography > Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                            </Typography>
                        </Grid>
                        <Grid item xs={2} > </Grid>
                        <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                            <Card className={`${styles.m_card}`}>
                                <Grid container spacing={1} sx={{}}>
                                    <Grid item xs={4} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>
                                            No Of Copies to be Printed
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={8}>
                                        <ERPinputNo
                                            size='small'
                                            fullWidth
                                            type="number"
                                            onChange={handleChangeNoofCopies}
                                            name="noOfCopies"
                                            value={noOfCopies}
                                            onInput={(e) => {
                                                e.target.value = Math.min(6, parseInt(e.target.value)).toString().slice(0, 1)
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={4} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>
                                            First Copy Title
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={(e) => (handleChangeTitle1(e))}
                                            name="title1"
                                            value={titles.title1}
                                            disabled={noOfCopies < 1}
                                        />
                                    </Grid>
                                    <Grid item xs={4} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>
                                            Second Copy Title
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={(e) => (handleChangeTitle2(e))}
                                            name="title2"
                                            value={titles.title2}
                                            disabled={noOfCopies < 2}
                                        />
                                    </Grid>
                                    <Grid item xs={4} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>
                                            Third Copy Title
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={(e) => (handleChangeTitle3(e))}
                                            name="title3"
                                            value={titles.title3}
                                            disabled={noOfCopies < 3}
                                        />
                                    </Grid>
                                    <Grid item xs={4} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>
                                            Fourth Copy Title
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={(e) => (handleChangeTitle4(e))}
                                            name="title4"
                                            value={titles.title4}
                                            disabled={noOfCopies < 4}
                                        />
                                    </Grid>
                                    <Grid item xs={4} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>
                                            Fifth Copy Title
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={(e) => (handleChangeTitle5(e))}
                                            name="title5"
                                            value={titles.title5}
                                            disabled={noOfCopies < 5}
                                        />
                                    </Grid>
                                    <Grid item xs={4} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>
                                            Sixth Copy Title
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <ERPinput
                                            size='small'
                                            fullWidth
                                            type="text"
                                            onChange={(e) => (handleChangeTitle6(e))}
                                            name="title6"
                                            value={titles.title6}
                                            disabled={noOfCopies < 6}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box sx={{ mt: 1,}}>
                                            <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                            <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} /> {rows.length > 0 ? 'Update' : 'Save'}
                                            </Button>
                                            <Cancel/>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    </Grid>

                </Box>


            </form>

            {
                successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage ? true : false}
                    autoHideDuration={2000}
                    onClose={handleCloseSuccessMsg}
                    message={successMessage}
                    action={actionMsg}
                />
            }

        </Paper >
        </>
    )
}
export default InvoicePrintTitleSetting;

